module.exports = __webpack_public_path__ + "img/icon-warning.d846dca2.svg";